import { createCommentVNode as _createCommentVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "tx-kb" }
const _hoisted_2 = ["aria-label"]
const _hoisted_3 = ["aria-expanded"]
const _hoisted_4 = { class: "tx-kb__nav" }
const _hoisted_5 = ["placeholder", "aria-label"]
const _hoisted_6 = ["href"]
const _hoisted_7 = {
  key: 0,
  class: "tx-muted tx-kb__none"
}
const _hoisted_8 = ["open"]
const _hoisted_9 = ["href", "aria-current"]
const _hoisted_10 = { class: "tx-kb__main" }
const _hoisted_11 = ["href"]
const _hoisted_12 = {
  key: 0,
  class: "tx-card tx-article"
}
const _hoisted_13 = { class: "tx-article__head" }
const _hoisted_14 = {
  key: 0,
  class: "tx-eyebrow"
}
const _hoisted_15 = { class: "tx-muted" }
const _hoisted_16 = ["innerHTML"]
const _hoisted_17 = {
  key: 1,
  class: "tx-card tx-feedback",
  "aria-live": "polite"
}
const _hoisted_18 = { class: "tx-feedback__row" }
const _hoisted_19 = ["aria-label"]
const _hoisted_20 = ["aria-pressed", "disabled", "title"]
const _hoisted_21 = ["aria-pressed", "disabled", "title"]
const _hoisted_22 = {
  key: 0,
  class: "tx-feedback__thanks"
}
const _hoisted_23 = ["onSubmit"]
const _hoisted_24 = ["disabled"]
const _hoisted_25 = {
  key: 2,
  class: "tx-feedback__thanks"
}
const _hoisted_26 = { class: "tx-feedback__next" }
const _hoisted_27 = ["href", "data-nav"]
const _hoisted_28 = ["aria-label"]
const _hoisted_29 = { class: "tx-related__list" }
const _hoisted_30 = ["href"]
const _hoisted_31 = {
  key: 0,
  class: "tx-eyebrow"
}
const _hoisted_32 = { class: "tx-pagehead" }
const _hoisted_33 = ["onSubmit"]
const _hoisted_34 = ["placeholder", "aria-label"]
const _hoisted_35 = { class: "tx-btn tx-btn--primary" }
const _hoisted_36 = {
  key: 0,
  class: "tx-chips tx-mb"
}
const _hoisted_37 = ["onClick"]
const _hoisted_38 = { class: "tx-cards" }
const _hoisted_39 = ["href"]
const _hoisted_40 = {
  key: 0,
  class: "tx-eyebrow"
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createCommentVNode(" Category-wise navigation (like a wiki sidebar). On phones it folds into a \"Browse articles\" button. "),
    _createElementVNode("aside", {
      class: _normalizeClass(["tx-kb__side", { open: $setup.navOpen }]),
      "aria-label": $setup.state.t('kb.browse')
    }, [
      _createElementVNode("button", {
        type: "button",
        class: "tx-kb__toggle",
        "aria-expanded": $setup.navOpen,
        onClick: _cache[0] || (_cache[0] = $event => ($setup.navOpen = !$setup.navOpen))
      }, [
        _createVNode($setup["Icon"], {
          name: "menu",
          size: "16"
        }),
        _createElementVNode("span", null, _toDisplayString($setup.state.t("kb.browse")), 1 /* TEXT */)
      ], 8 /* PROPS */, _hoisted_3),
      _createElementVNode("div", _hoisted_4, [
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => (($setup.navFilter) = $event)),
          type: "search",
          class: "tx-kb__filter",
          placeholder: $setup.state.t('kb.filter'),
          "aria-label": $setup.state.t('kb.filter')
        }, null, 8 /* PROPS */, _hoisted_5), [
          [
            _vModelText,
            $setup.navFilter,
            void 0,
            { trim: true }
          ]
        ]),
        _createElementVNode("a", {
          href: $setup.link('knowledge'),
          "data-nav": "",
          class: _normalizeClass(["tx-kb__all", { on: $setup.route.name === 'knowledge' && !$setup.category }])
        }, [
          _createVNode($setup["Icon"], {
            name: "book",
            size: "16"
          }),
          _createTextVNode(_toDisplayString($setup.state.t("kb.all")), 1 /* TEXT */)
        ], 10 /* CLASS, PROPS */, _hoisted_6),
        (!$setup.navGroups.length && $setup.navFilter)
          ? (_openBlock(), _createElementBlock("p", _hoisted_7, _toDisplayString($setup.state.t("kb.no_match")), 1 /* TEXT */))
          : _createCommentVNode("v-if", true),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.navGroups, (g) => {
          return (_openBlock(), _createElementBlock("details", {
            key: g.name || '_general',
            class: "tx-kb__group",
            open: $setup.isOpen(g)
          }, [
            _createElementVNode("summary", null, [
              _createElementVNode("span", null, _toDisplayString(g.label), 1 /* TEXT */),
              _createElementVNode("small", null, _toDisplayString(g.articles.length), 1 /* TEXT */)
            ]),
            _createElementVNode("ul", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(g.articles, (a) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: a.name
                }, [
                  _createElementVNode("a", {
                    href: $setup.link('knowledge/' + a.name),
                    "data-nav": "",
                    class: _normalizeClass({ on: a.name === $setup.route.params.id }),
                    "aria-current": a.name === $setup.route.params.id ? 'page' : null
                  }, _toDisplayString(a.title), 11 /* TEXT, CLASS, PROPS */, _hoisted_9)
                ]))
              }), 128 /* KEYED_FRAGMENT */))
            ])
          ], 8 /* PROPS */, _hoisted_8))
        }), 128 /* KEYED_FRAGMENT */))
      ])
    ], 10 /* CLASS, PROPS */, _hoisted_2),
    _createElementVNode("div", _hoisted_10, [
      ($setup.route.name === 'article')
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createElementVNode("a", {
              href: $setup.link('knowledge'),
              "data-nav": "",
              class: "tx-backlink"
            }, [
              _createVNode($setup["Icon"], {
                name: "back",
                size: "16"
              }),
              _createTextVNode(_toDisplayString($setup.state.t("kb.title")), 1 /* TEXT */)
            ], 8 /* PROPS */, _hoisted_11),
            _createVNode($setup["Loader"], {
              loading: $setup.loading,
              error: $setup.error,
              onRetry: $setup.loadArticle
            }, {
              default: _withCtx(() => [
                ($setup.article)
                  ? (_openBlock(), _createElementBlock("article", _hoisted_12, [
                      _createElementVNode("div", _hoisted_13, [
                        _createElementVNode("div", null, [
                          ($setup.article.category)
                            ? (_openBlock(), _createElementBlock("p", _hoisted_14, _toDisplayString($setup.categoryLabel($setup.article.category)), 1 /* TEXT */))
                            : _createCommentVNode("v-if", true),
                          _createElementVNode("h1", null, _toDisplayString($setup.article.title), 1 /* TEXT */),
                          _createElementVNode("small", _hoisted_15, _toDisplayString($setup.state.t("kb.updated")) + " " + _toDisplayString($setup.fmtDate($setup.article.modified)), 1 /* TEXT */)
                        ]),
                        _createElementVNode("button", {
                          type: "button",
                          class: "tx-btn tx-btn--ghost tx-btn--sm tx-copy",
                          onClick: $setup.copyLink
                        }, [
                          _createVNode($setup["Icon"], {
                            name: $setup.copied ? 'check' : 'link',
                            size: "16"
                          }, null, 8 /* PROPS */, ["name"]),
                          _createElementVNode("span", null, _toDisplayString($setup.copied ? $setup.state.t("kb.copied") : $setup.state.t("kb.copy_link")), 1 /* TEXT */)
                        ])
                      ]),
                      _createElementVNode("div", {
                        class: "tx-prose",
                        innerHTML: $setup.article.content
                      }, null, 8 /* PROPS */, _hoisted_16)
                    ]))
                  : _createCommentVNode("v-if", true),
                _createCommentVNode(" Was this article helpful? "),
                ($setup.article)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                      _createElementVNode("div", _hoisted_18, [
                        _createElementVNode("strong", null, _toDisplayString($setup.state.t("kb.helpful_q")), 1 /* TEXT */),
                        _createElementVNode("div", {
                          class: "tx-feedback__votes",
                          role: "group",
                          "aria-label": $setup.state.t('kb.helpful_q')
                        }, [
                          _createElementVNode("button", {
                            type: "button",
                            class: _normalizeClass(["tx-vote", { on: $setup.vote === 'Helpful' }]),
                            "aria-pressed": $setup.vote === 'Helpful',
                            disabled: $setup.voting,
                            title: $setup.state.t('kb.yes'),
                            onClick: _cache[2] || (_cache[2] = $event => ($setup.sendVote('Helpful')))
                          }, [
                            _createVNode($setup["Icon"], {
                              name: "thumbs_up",
                              size: "18"
                            }),
                            _createElementVNode("span", null, _toDisplayString($setup.state.t("kb.yes")), 1 /* TEXT */)
                          ], 10 /* CLASS, PROPS */, _hoisted_20),
                          _createElementVNode("button", {
                            type: "button",
                            class: _normalizeClass(["tx-vote", { on: $setup.vote === 'Not Helpful' }]),
                            "aria-pressed": $setup.vote === 'Not Helpful',
                            disabled: $setup.voting,
                            title: $setup.state.t('kb.no'),
                            onClick: _cache[3] || (_cache[3] = $event => ($setup.sendVote('Not Helpful')))
                          }, [
                            _createVNode($setup["Icon"], {
                              name: "thumbs_down",
                              size: "18"
                            }),
                            _createElementVNode("span", null, _toDisplayString($setup.state.t("kb.no")), 1 /* TEXT */)
                          ], 10 /* CLASS, PROPS */, _hoisted_21)
                        ], 8 /* PROPS */, _hoisted_19)
                      ]),
                      ($setup.vote === 'Helpful')
                        ? (_openBlock(), _createElementBlock("p", _hoisted_22, _toDisplayString($setup.state.t("kb.thanks")), 1 /* TEXT */))
                        : _createCommentVNode("v-if", true),
                      ($setup.vote === 'Not Helpful' && !$setup.commentSent)
                        ? (_openBlock(), _createElementBlock("form", {
                            key: 1,
                            class: "tx-feedback__more",
                            onSubmit: _withModifiers($setup.sendComment, ["prevent"])
                          }, [
                            _createElementVNode("label", null, [
                              _createElementVNode("span", null, _toDisplayString($setup.state.t("kb.what_missing")), 1 /* TEXT */),
                              _withDirectives(_createElementVNode("textarea", {
                                "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => (($setup.comment) = $event)),
                                rows: "2",
                                maxlength: "1000"
                              }, null, 512 /* NEED_PATCH */), [
                                [
                                  _vModelText,
                                  $setup.comment,
                                  void 0,
                                  { trim: true }
                                ]
                              ])
                            ]),
                            _createElementVNode("button", {
                              class: "tx-btn tx-btn--sm",
                              disabled: !$setup.comment || $setup.voting
                            }, _toDisplayString($setup.state.t("kb.send")), 9 /* TEXT, PROPS */, _hoisted_24)
                          ], 40 /* PROPS, NEED_HYDRATION */, _hoisted_23))
                        : _createCommentVNode("v-if", true),
                      ($setup.commentSent)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_25, _toDisplayString($setup.state.t("kb.thanks_comment")), 1 /* TEXT */))
                        : _createCommentVNode("v-if", true),
                      _createCommentVNode(" If your issue isn't resolved, raise a support ticket "),
                      _createElementVNode("div", _hoisted_26, [
                        _createElementVNode("span", null, _toDisplayString($setup.state.t("kb.not_resolved")), 1 /* TEXT */),
                        ($setup.ticketHref)
                          ? (_openBlock(), _createElementBlock("a", {
                              key: 0,
                              href: $setup.ticketHref,
                              "data-nav": $setup.state.isGuest || !$setup.state.linked ? null : '',
                              class: "tx-btn tx-btn--primary tx-btn--sm"
                            }, [
                              _createVNode($setup["Icon"], {
                                name: "ticket",
                                size: "16"
                              }),
                              _createTextVNode(_toDisplayString($setup.state.isGuest ? $setup.state.t("kb.login_raise") : $setup.state.t("kb.raise_here")), 1 /* TEXT */)
                            ], 8 /* PROPS */, _hoisted_27))
                          : _createCommentVNode("v-if", true),
                        ($setup.state.modules.chat)
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 1,
                              type: "button",
                              class: "tx-btn tx-btn--sm",
                              onClick: _cache[5] || (_cache[5] = $event => ($setup.openChat()))
                            }, [
                              _createVNode($setup["Icon"], {
                                name: "chat",
                                size: "16"
                              }),
                              _createTextVNode(_toDisplayString($setup.state.t("kb.chat")), 1 /* TEXT */)
                            ]))
                          : _createCommentVNode("v-if", true)
                      ])
                    ]))
                  : _createCommentVNode("v-if", true),
                _createCommentVNode(" Related articles "),
                ($setup.relatedArticles.length)
                  ? (_openBlock(), _createElementBlock("section", {
                      key: 2,
                      class: "tx-related",
                      "aria-label": $setup.state.t('kb.related')
                    }, [
                      _createElementVNode("h2", null, _toDisplayString($setup.state.t("kb.related")), 1 /* TEXT */),
                      _createElementVNode("div", _hoisted_29, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.relatedArticles, (r) => {
                          return (_openBlock(), _createElementBlock("a", {
                            key: r.name,
                            href: $setup.link('knowledge/' + r.name),
                            "data-nav": "",
                            class: "tx-card tx-kbcard"
                          }, [
                            (r.category)
                              ? (_openBlock(), _createElementBlock("small", _hoisted_31, _toDisplayString($setup.categoryLabel(r.category)), 1 /* TEXT */))
                              : _createCommentVNode("v-if", true),
                            _createElementVNode("strong", null, _toDisplayString(r.title), 1 /* TEXT */)
                          ], 8 /* PROPS */, _hoisted_30))
                        }), 128 /* KEYED_FRAGMENT */))
                      ])
                    ], 8 /* PROPS */, _hoisted_28))
                  : _createCommentVNode("v-if", true)
              ]),
              _: 1 /* STABLE */
            }, 8 /* PROPS */, ["loading", "error"])
          ], 64 /* STABLE_FRAGMENT */))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _createElementVNode("div", _hoisted_32, [
              _createElementVNode("h1", null, _toDisplayString($setup.category ? $setup.categoryLabel($setup.category) : $setup.state.t("kb.title")), 1 /* TEXT */)
            ]),
            _createElementVNode("form", {
              class: "tx-search tx-search--hero",
              role: "search",
              onSubmit: _withModifiers($setup.search, ["prevent"])
            }, [
              _createVNode($setup["Icon"], { name: "search" }),
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => (($setup.q) = $event)),
                type: "search",
                placeholder: $setup.state.t('kb.search'),
                "aria-label": $setup.state.t('kb.search')
              }, null, 8 /* PROPS */, _hoisted_34), [
                [
                  _vModelText,
                  $setup.q,
                  void 0,
                  { trim: true }
                ]
              ]),
              _createElementVNode("button", _hoisted_35, _toDisplayString($setup.state.t("common.search")), 1 /* TEXT */)
            ], 40 /* PROPS, NEED_HYDRATION */, _hoisted_33),
            ($setup.categories.length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                  _createElementVNode("button", {
                    class: _normalizeClass(["tx-filter", { on: !$setup.category }]),
                    onClick: _cache[7] || (_cache[7] = $event => ($setup.pick('')))
                  }, _toDisplayString($setup.state.t("kb.all")), 3 /* TEXT, CLASS */),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.categories, (c) => {
                    return (_openBlock(), _createElementBlock("button", {
                      key: c.name,
                      class: _normalizeClass(["tx-filter", { on: $setup.category === c.name }]),
                      onClick: $event => ($setup.pick(c.name))
                    }, _toDisplayString(c.label), 11 /* TEXT, CLASS, PROPS */, _hoisted_37))
                  }), 128 /* KEYED_FRAGMENT */))
                ]))
              : _createCommentVNode("v-if", true),
            _createVNode($setup["Loader"], {
              loading: $setup.loading,
              error: $setup.error,
              onRetry: $setup.search
            }, {
              default: _withCtx(() => [
                (!$setup.results.length)
                  ? (_openBlock(), _createBlock($setup["Empty"], {
                      key: 0,
                      icon: "book"
                    }))
                  : _createCommentVNode("v-if", true),
                _createElementVNode("div", _hoisted_38, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.results, (a) => {
                    return (_openBlock(), _createElementBlock("a", {
                      key: a.name,
                      href: $setup.link('knowledge/' + a.name),
                      "data-nav": "",
                      class: "tx-card tx-kbcard"
                    }, [
                      (a.category)
                        ? (_openBlock(), _createElementBlock("small", _hoisted_40, _toDisplayString($setup.categoryLabel(a.category)), 1 /* TEXT */))
                        : _createCommentVNode("v-if", true),
                      _createElementVNode("strong", null, _toDisplayString(a.title), 1 /* TEXT */),
                      _createElementVNode("p", null, _toDisplayString(a.excerpt), 1 /* TEXT */)
                    ], 8 /* PROPS */, _hoisted_39))
                  }), 128 /* KEYED_FRAGMENT */))
                ])
              ]),
              _: 1 /* STABLE */
            }, 8 /* PROPS */, ["loading", "error"])
          ], 64 /* STABLE_FRAGMENT */))
    ])
  ]))
}